import Modal from 'react-overlays/Modal'

export default function SoilDetailModal({
  soilType,
  soilDetail,
  showSoilDetailModal,
  setShowSoilDetailModal,
}) {
  const handleClose = () => {
    setShowSoilDetailModal(false)
  }

  const renderBackdrop = (props) => <div className="backdrop" {...props} />

  return (
    <>
      <div className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[200]"></div>
      <div>
        <Modal
          className="modal"
          show={showSoilDetailModal}
          onHide={handleClose}
          renderBackdrop={renderBackdrop}
          style={{
            // display: 'flex',
            position: 'absolute',
            top: '30%',
            left: '50%',
            marginTop: '-170px',
            marginLeft: '-250px',
            width: '500px',
            height: '70%',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050,
          }}
        >
          <div>
            <div className="modal-header">
              <div className="modal-title">Soil Detail ({soilType})</div>
              <div>
                <span className="close-button" onClick={handleClose}>
                  x
                </span>
              </div>
            </div>
            <div
              className="modal-desc"
              dangerouslySetInnerHTML={{ __html: soilDetail }}
            ></div>
          </div>
        </Modal>
      </div>
    </>
  )
}
